export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-iphone-4.f797ad69.svg";